export enum PayoutType {
  Crypto = 'Crypto',
  Fiat = 'Fiat'
}

export enum PayoutSteps {
  SelectAssets,
  SelectDetails,
  ReviewAndConfirm
}

export const HEDGED_PAYOUT_DESTINATION_NETWORKS_USDC = [
  'Bitcoin',
  'Ethereum',
  'Solana',
  'Litecoin',
  'Dogecoin',
  'BitcoinCash',
  'Avalanche',
  'Polkadot'
]

export const HEDGED_PAYOUT_DESTINATION_NETWORKS_USDT = [
  ...HEDGED_PAYOUT_DESTINATION_NETWORKS_USDC,
  'Polygon',
  'Tron'
]

export const HEDGED_PAYOUT_FUNDING_NETWORK = 'Ethereum'
